import React from 'react';
import {
    View,
    TextInput,
    Text,
    StyleSheet,
    ViewStyle,
    TextInputProps,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { theme } from '../constants/theme';

interface CustomInputProps extends TextInputProps {
    label: string;
    error?: string;
    icon?: string;
    containerStyle?: ViewStyle;
}

export const CustomInput: React.FC<CustomInputProps> = ({
    label,
    error,
    icon,
    containerStyle,
    editable = true,
    ...props
}) => {
    const isDisabled = editable === false;

    return (
        <View style={[styles.container, containerStyle]}>
            <Text style={styles.label}>{label}</Text>
            <View style={[
                styles.inputContainer,
                error && styles.inputContainer_error,
                isDisabled && styles.inputContainer_disabled
            ]}>
                {icon && (
                    <Icon
                        name={icon}
                        size={20}
                        color={isDisabled ? theme.colors.textLight : theme.colors.textSecondary}
                        style={styles.icon}
                    />
                )}
                <TextInput
                    style={[
                        styles.input,
                        icon && styles.input_withIcon,
                        isDisabled && styles.input_disabled
                    ]}
                    placeholderTextColor={theme.colors.textLight}
                    editable={editable}
                    {...props}
                />
            </View>
            {error && <Text style={styles.error}>{error}</Text>}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginBottom: theme.spacing.md,
    },
    label: {
        ...theme.typography.body2,
        color: theme.colors.text,
        marginBottom: theme.spacing.sm,
        fontWeight: '600',
    },
    inputContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: theme.colors.surface,
        borderRadius: theme.borderRadius.lg,
        borderWidth: 1,
        borderColor: theme.colors.border,
        paddingHorizontal: theme.spacing.sm,
    },
    inputContainer_error: {
        borderColor: theme.colors.error,
    },
    inputContainer_disabled: {
        backgroundColor: theme.colors.border + '40',
        borderColor: theme.colors.border,
    },
    icon: {
        marginRight: theme.spacing.xs,
    },
    input: {
        flex: 1,
        ...theme.typography.body2,
        color: theme.colors.text,
        paddingVertical: theme.spacing.md,

    },
    input_withIcon: {
        paddingLeft: 0,
    },
    input_disabled: {
        color: theme.colors.textSecondary,
    },
    error: {
        ...theme.typography.caption,
        color: theme.colors.error,
        marginTop: theme.spacing.xs,
    },
});
